import axios from "axios";
import { baseURL } from "../config";

export const deleteEntry = async (itemId, time) => {
  try {
    console.log("i got called ");
    const response = await axios.post(`${baseURL}/deleteEntry`, { data: { itemId, time } });

    // Check if the response is successful (status code 200)
    if (response.status === 200) {
      return true;
    } else {
      // If status is not 200, throw an error with the status code and message
      throw new Error(`Failed to delete entry. Status: ${response.status}, Message: ${response.statusText}`);
    }
  } catch (error) {
    // Log the error and throw it to propagate to the calling function
    console.error("Error deleting entry:", error);
    throw error; // Re-throw the error
  }
};
